import { Box, Button, TextField, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import { useTranslation } from '../../hooks/useTranslation';

const ConsultFilters = ({ documentFilter, onDocumentChange, onSearch }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        marginBottom: 3,
      }}
    >
      <TextField
        fullWidth
        placeholder={t('forms.cpfCnpj')}
        variant="outlined"
        value={documentFilter}
        onChange={(e) => onDocumentChange(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onSearch();
          }
        }}
        InputProps={{
          sx: {
            backgroundColor: '#fff',
            borderRadius: '4px',
            color: colors.grey[400],
            '& fieldset': {
              borderColor: colors.primary[400],
            },
            '&:hover fieldset': {
              borderColor: colors.greenAccent[400],
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.greenAccent[400],
            },
          },
        }}
        sx={{
          maxWidth: { xs: '100%', md: '400px' },
          height: '100%',
        }}
      />

      <Button
        variant="contained"
        onClick={onSearch}
        sx={{
          backgroundColor: colors.greenAccent[600],
          color: colors.grey[100],
          fontWeight: 700,
          textTransform: 'uppercase',
          fontSize: '12px',
          padding: '16px',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: colors.greenAccent[700],
          },
        }}
      >
        {t('buttons.consultClient')}
      </Button>
    </Box>
  );
};

export default ConsultFilters;
